<script>
export default {}
</script>

<template>
  <div class="mb-4">
    <div class="flex flex-col lg:flex-row">
      <div class="flex-1 mb-4">
        <slot name="title"></slot>
      </div>
      <div class="flex flex-col lg:flex-row">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>
